import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import Media from '../../models/media';
import styles from './location-search.module.scss';
import useGooglePlaces from '../../hooks/useGooglePlaces';
import kp from '../../helpers/keypress';
import GoogleTagManagerService from '../../services/googleTagManager';

type Props = {
  icon?: Media;
  placeholder?: string;
  setResults: (results: any) => void;
  defaultCenter: any;
};

const LocationSearch = ({
  icon,
  placeholder,
  setResults,
  defaultCenter
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const resultsRef = useRef(null);
  const { results, findPlace } = useGooglePlaces(resultsRef);

  useEffect(() => {
    if (results) {
      setResults(results);
    }
  }, [results]);

  const search = () => {
    if (inputRef?.current?.value && inputRef?.current?.value.length > 1) {
      findPlace(inputRef?.current?.value, defaultCenter);

      GoogleTagManagerService.dataLayerMapSearch(inputRef?.current?.value);
    }
  };

  return (
    <>
      <div className={styles['location-search']}>
        <input
          name="places"
          className={styles['location-search__input']}
          placeholder={placeholder}
          ref={inputRef}
          onKeyPress={kp(search)}
        />
        <button
          onClick={() => search()}
          type="button"
          className={styles['location-search__button']}
          name="location search"
        >
          {icon && (
            <Image
              alt={icon.alt}
              src={icon.src}
              height={icon.height}
              width={icon.width}
              layout="fixed"
            />
          )}
        </button>
      </div>
      <div ref={resultsRef} />
    </>
  );
};

export default LocationSearch;
